module.exports = __webpack_public_path__ + "img/order-sn.0f493391.png";